import { apiSlice } from '@/core/api/apiSlice';
import { ApiResponse } from '@/types/common.types';
import { SignupRequest, LoginRequest, AuthResponseData } from '@/types/auth.types';

export const authApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        adminSignup: builder.mutation<ApiResponse<AuthResponseData>, SignupRequest>({
            query: (credentials) => ({
                url: '/auth/signup',
                method: 'POST',
                body: credentials,
            }),
        }),
        adminLogin: builder.mutation<ApiResponse<AuthResponseData>, LoginRequest>({
            query: (credentials) => ({
                url: '/auth/login',
                method: 'POST',
                body: credentials,
            }),
        }),
    }),
});

export const {
    useAdminSignupMutation,
    useAdminLoginMutation,
} = authApi;
